module.exports = Vuetify;